import React from 'react'
import styled from 'styled-components'
import { PageFactory } from '../Page'

const EventTheme = styled.p.attrs(({ text }) => ({ children: text }))`
  font-size: 30px;
  font-style: italic;
`

const HomeBasePost = PageFactory({
  renderers: {
    EventTheme,
  },
})

const Home = () => <HomeBasePost which="ga" />

export default Home
